const selectors = {
  productContainer: document.querySelector('.product-details-wrapper'),
  productMedia: document.querySelector('[data-productMedia]'),
  addToCartContainer: document.querySelector('.addtocart-container'),
  addToCartCTA: document.querySelector('.addtocart-cta')
};


const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
window.productMedia = mediaJSON;
class TemplateProductJS {
  constructor() {
    // Custom code for product page goes here

    window.addEventListener('resize', this.productSlider);
    this.productSlider();
    this.stickyCheckout();
  }
  productSlider() {
    let pdpSliderInstance = '';
    if (window.innerWidth <= 991) {
      var sliderThumbnail = new Swiper('.product-thumbnails', {
                                  slidesPerView: 5,
                                  spaceBetween: 1,
                                  grabCursor: true,
                                  slideToClickedSlide: true,
                                  watchSlidesVisibility: true,
                                  watchSlidesProgress: true,
                                  roundLengths: true,
                                  centerInsufficientSlides:true,
                                  navigation: {
                                    nextEl: ".product-thumbnails-next",
                                    prevEl: ".product-thumbnails-prev"
                                  },
                                  breakpoints: {
                                    380: {
                                      slidesPerView: 6
                                    },
                                    576: {
                                      spaceBetween: 5,
                                      slidesPerView:"auto"
                                    }
                                }
      });
      pdpSliderInstance = new Swiper('.product-carousel', {
        grabCursor: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        thumbs: {
          swiper: sliderThumbnail
        }
      });
    } else if(pdpSliderInstance != '') {
      pdpSliderInstance.destroy()
    }
  } 
  stickyCheckout() {
    if (!selectors.addToCartContainer || !selectors.addToCartCTA) return;

    const stickyEl = selectors.addToCartCTA;
    const htmlEl = document.documentElement;

    // Ensure smooth transition is set
    stickyEl.style.transition = 'bottom 0.3s, background 0.3s';

    let ticking = false;
    let lastState = false; // Tracks whether sticky is active to avoid rapid add/remove

    const applyHtmlPadding = () => {
      if (!stickyEl.classList.contains('sticky-btn')) {
        htmlEl.style.paddingBottom = '';
        return;
      }
      const height = Math.ceil(stickyEl.getBoundingClientRect().height || 0);
      htmlEl.style.paddingBottom = height ? `${height}px` : '';
    };

    const updateStickyState = () => {
      const elementTop = selectors.addToCartContainer.getBoundingClientRect().top;
      const isSticky = elementTop < 0;

      if (isSticky !== lastState) {
        if (isSticky) {
          // To ensure smoothness: wait a tick to add class so css transitions apply
          requestAnimationFrame(() => {
            stickyEl.classList.add('sticky-btn');
            applyHtmlPadding();
          });
        } else {
          stickyEl.classList.remove('sticky-btn');
          applyHtmlPadding();
        }
        lastState = isSticky;
      }
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateStickyState);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', applyHtmlPadding);
    // Set initial state
    updateStickyState();
  }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();